import { render } from "./ClaimToken.vue?vue&type=template&id=7084bdc1"
import script from "./ClaimToken.vue?vue&type=script&lang=js"
export * from "./ClaimToken.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__